/**
 * Process Designer BPMN — rotas (E18.2.1, FR-E18-1).
 *
 * Rota DEDICADA ``/process-designer`` (⚠️ NÃO ``/processos``, que é do módulo
 * ProcessoParceiro/Portal de Substabelecidos). As páginas são lazy (o chunk bpmn-js
 * ~700KB só carrega ao abrir o editor). Permissão ``process_designer:read/create``
 * seedada no backend (process_designer_permissions_seed); ``RequirePermission`` evita
 * o request inútil de quem não tem acesso.
 */

import { lazy } from "react";

import { ModuleRoutes } from "../types";

const ProcessDesignerListPage = lazy(
  () => import("@/pages/process-designer/ProcessDesignerListPage"),
);
const ProcessDesignerEditorPage = lazy(
  () => import("@/pages/process-designer/ProcessDesignerEditorPage"),
);

export const processDesignerRoutes: ModuleRoutes = {
  moduleId: "process_designer",
  basePath: "/process-designer",
  routes: [
    {
      path: "/process-designer",
      element: <ProcessDesignerListPage />,
      permission: { resource: "process_designer", action: "read" },
    },
    {
      // estática antes da dinâmica :id (e o React Router prioriza estática mesmo assim)
      path: "/process-designer/novo",
      element: <ProcessDesignerEditorPage />,
      permission: { resource: "process_designer", action: "create" },
    },
    {
      path: "/process-designer/:id",
      element: <ProcessDesignerEditorPage />,
      permission: { resource: "process_designer", action: "read" },
    },
  ],
};
